import { faUserDoctor, faLaptopMobile } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CardInstitutionalProps } from '@/app/(main)/(pages)/(institucional)/_types/card-institutional.types';
import { beOurPartnerUrl } from '@/utils/consts/partner.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const ourOpportunitiesTopics: CardInstitutionalProps[] = [
  {
    title: 'Médicos e profissionais de saúde',
    titleIcon: faUserDoctor,
    description: 'Atenda seus pacientes pela Medprev e receba em até 7 dias úteis. É fácil, rápido e sem custo.',
    buttons: [
      {
        text: 'Seja nosso parceiro',
        action: 'link',
        link: beOurPartnerUrl,
        rel: 'noopener noreferrer',
        target: '_blank',
        variant: 'secondary',
        dataTestID: DataTestIdEnum.WORK_WITH_US_BUTTON_BECOME_OUR_PARTNER,
        ['data-analytics-event']: AnalyticsEnum.CLICK_WORK_WITH_US_BE_OUR_PARTNER,
      },
    ],
  },
  {
    title: 'Tecnologia, produto, design, CS, marketing e administrativo',
    titleIcon: faLaptopMobile,
    description: 'Se você é apaixonado por inovação, criatividade e eficiência, temos o lugar certo para você.',
    buttons: [
      {
        text: 'Conferir vagas',
        action: 'link',
        link: 'https://vagasmedprevonline.vagas.solides.com.br/',
        rel: 'noopener noreferrer',
        target: '_blank',
        variant: 'secondary',
        dataTestID: DataTestIdEnum.WORK_WITH_US_BUTTON_CHECK_OPPORTUNITIES,
        ['data-analytics-event']: AnalyticsEnum.CLICK_WORK_WITH_US_OPEN_POSITIONS,
      },
    ],
  },
];
